import styled from "styled-components"
import { Colors } from "styles/app-styles"
import DataTable_s from "components/table/data-table-styles"
import { FormSection } from 'styles/form-styles'
import { CarouselTabs_s } from "components/table/carousel/carousel-styles"

export const Users_s = styled.div`
  #addUserModal input {
    margin-bottom: 10px;
  }

  .p-paginator {
    bottom: 0px;
  }

  .r-svg {
    fill: ${Colors.blackPearl};
  }

  ${DataTable_s}{
    height: calc(100vh - 160px);
  }

  ${FormSection}{
    > div {
      display: flex;
      flex-direction: column;
    }
    > div:last-child {
      flex-direction: row;
      justify-content: space-between;
      margin-top: 10px;
    }
  }
`

export const UserGroups_s = styled.div`
  .p-paginator {
    bottom: 0px;
  }

  .systemImmutable-row {
    background: ${Colors.athensGrey} !important;
  }
  .system-row .system-disabled {
    background: ${Colors.athensGrey};
  }
`

export const UserGroupTable_s = styled(DataTable_s)`
  border-spacing: 15px;

  table.p-datatable-scrollable-header-table, table.p-datatable-scrollable-body-table {
    width: auto;
  }

  table.p-datatable-scrollable-body-table {
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  }

  .p-datatable-thead > tr {
    height: 30px;
  }



  // Hide filter input row
  .p-datatable-unfrozen-view thead.p-datatable-thead > tr:last-child {
    display: none;
  }

  ${CarouselTabs_s}{
    display: none;
  }

  // Users listbox style overrides
  li.p-listbox-item {
    height: auto;
  }
`

export const UserTable_s = styled(DataTable_s)`
  border-spacing: 15px;

  table.p-datatable-scrollable-header-table, table.p-datatable-scrollable-body-table {
    width: auto;
  }

  .p-datatable-scrollable-body {
    height: calc(100vh - 160px);
  }

  table.p-datatable-scrollable-body-table {
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  }

  .p-datatable-thead > tr {
    height: 30px;
  }



  // Hide filter input row
  .p-datatable-unfrozen-view thead.p-datatable-thead > tr:last-child {
    display: none;
  }

  .p-editable-column > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export const ShowSelected_s = styled.div`
  width: 120px;
`

export const OrgSettings_s = styled.div`
  margin: 25px 10px 0 25px;
  label {
    font-size: 16px;
    font-family: 'Roboto-Light',sans-serif;
  }
`
